module.exports = __webpack_public_path__ + "static/img/Alfian Azizi-close.dc98bf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Alfian Azizi-close.jpg
// module id = SHd7
// module chunks = 1